import styled from 'styled-components';

export const DownloadButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
`;
